import { useCallback, useMemo } from 'react';
import { useUserContext } from '@sierralabs/user-ui';
import { useSiteContext } from '../../SiteContext';
import { useSiteRouteComponents } from '../site-route/useSiteRouteComponents';
// automatically filter out navigation
// based on configured permissions for routes
export function useSiteNavigationFilter() {
    const routes = useSiteRouteComponents();
    const { user } = useUserContext();
    const { routePermissions: defaultRoutePermissions, routeHasAccess } = useSiteContext();
    const permissions = useMemo(() => {
        const routePermissions = routes.map(route => {
            var _a, _b;
            const path = ((_a = route.props) === null || _a === void 0 ? void 0 : _a.path) || '';
            return { path, permissions: ((_b = route.props) === null || _b === void 0 ? void 0 : _b.permissions) || [] };
        });
        return defaultRoutePermissions.concat(...routePermissions);
    }, [defaultRoutePermissions, routes]);
    const filter = useCallback((navigation) => {
        if (!user || !routeHasAccess) {
            return navigation;
        }
        return navigation.filter(nav => {
            const item = permissions.find(permission => permission.path === nav.path);
            const itemPermissions = (item === null || item === void 0 ? void 0 : item.permissions) || [];
            return (itemPermissions.length === 0 ||
                itemPermissions.some(permission => routeHasAccess(user, permission)));
        });
    }, [permissions, user, routeHasAccess]);
    return { permissions, filter };
}
//# sourceMappingURL=useSiteNavigationFilter.js.map